import { render } from "./BaseListTitle.vue?vue&type=template&id=48c47870"
import script from "./BaseListTitle.vue?vue&type=script&lang=js"
export * from "./BaseListTitle.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__